<template>
    <div style="background-color: #fff; border-bottom: 1px solid #ddd;">
        <div @click="onClick" class="pm-message-item" :class="message.read === 0 ? 'pm-message-item-unread' : 'pm-message-item-read'">
            <div :key="message.read" style="width: 50px; padding: 0 10px 0 0; text-align: center; align-self: center;">
                <mdi v-if="message.mdi" size="24">{{  message.mdi }}</mdi>
                <mdi v-if="!message.mdi && message.read === 0" size="24">mdiEmailOutline</mdi>
                <mdi v-if="!message.mdi && message.read !== 0" size="24">mdiEmailOpenOutline</mdi>
            </div>
            <div style="width: Calc(100vw - 140px);">
                <div style="font-size: 15px; width: 100%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;" class="pm-message-item-title">
                    {{ message.subject }}
                    <small style="font-size: 10px;" v-if="message.ad">(ad)</small>
                </div>

                <div class="pm-message-item-text" style="font-size: 13px; width: 100%; color: #444!important; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;" >{{ message.text }}</div>
            </div>
            <div style="font-weight: normal!important; font-size: 13px; text-align: right; width: 60px;">{{ message.shown | toDateTime }}</div>
        </div>

        <transition name="pm-fade-in-slide-up-transition">
            <component v-if="message.component && opened" v-bind:is="message.component"></component>
        </transition>


        <transition name="pm-fade-in-slide-up-transition">
            <pm-custom-dialog v-if="!message.component && !message.callback && opened" v-model="opened">
                <div v-if="message.img" :style="'background: url(' + message.img+ ') center center / contain no-repeat rgb(255, 255, 255); margin: 0px 0px 20px 0; width: 100%; height: 170px;'"></div>

                <div class="message-item-dialog" style="padding: 0 32px; text-align: center;">
                    <h2 style="margin-bottom: 32px; line-height: 1.5; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;" v-html="message.fullsubject ? message.fullsubject : message.subject"></h2>
                    <div v-html="message.fulltext ? message.fulltext : message.text"></div>
                </div>
                <br/>
                <span @click="opened = false" style="text-decoration: underline;">close</span>
            </pm-custom-dialog>
        </transition>
    </div>
</template>

<style>
    .message-item-dialog b, .message-item-dialog b * {
        font-weight: 600!important;
    }
    .message-item-dialog button,
    .message-item-dialog a.message-button
    {
        display: inline-block;
        background: #2979ff;
        color: white;
        border: none;
        border-radius: 20px;
        padding: 8px 24px;
        text-decoration: none;
    }
    .message-item-dialog em {
        border-radius: 7px;;
        display: block;
        padding: 14px;
        background: #eee;
        font-size: 14px;
        line-height: 1.3;
        font-style: normal;
        margin: 10px 0;
    }
    .pm-message-item {
        display: flex;
        align-items: flex-start;
        width: 100%;
        padding: 16px 10px;
        background: #fff;
    }
    .pm-message-item-unread {
        background: #fff;
    }
    .pm-message-item-unread * {
        font-weight: 600;
        color: black;
    }
    .pm-message-item-read {
        opacity: .6;
    }

    .pm-message-item-unread .pm-message-item-title {
        color: #000!important;
        font-weight: 800;
    }
    .pm-message-item-unread .pm-message-item-text {

    }
</style>

<script>
import PmCustomDialog from "@/components/dialogs/base-dialog.vue";
import { setMessageReadStatus } from "@/configs/in-app-messages"
export default {
    components: {
        PmCustomDialog
    },
    props: {
        message: {
            type: Object,
        }
    },
    data: () => ({
        opened: false,

    }),
    methods: {
        onClick() {
            this.opened = true;
            this.$nextTick(() => {
                setMessageReadStatus(this.message);
                if (this.message.callback) this.message.callback(this);
            });

        },
    },
    filters: {
        toDateTime(value) {
            try {
                const t = parseInt(value);
                return new Intl.DateTimeFormat([app.$store.state.language, 'en-US'],  { month: 'short', day: 'numeric' }).format(t);
            } catch(error) {
                console.error(error);
                return "";
            }
        }
    }
}
</script>
